import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { Whiteboard, WhiteboardDto, WhiteboardTemplatePayload } from "@webapp/whiteboards/models/whiteboard.models";
import { WhiteboardsState } from "@webapp/whiteboards/services/whiteboards-state.service";
import { WhiteboardsApiService } from "./whiteboards-api.service";

@Injectable({
  providedIn: "any",
})
export class WhiteboardsFacade extends BaseFacade<Whiteboard, WhiteboardDto, WhiteboardsState, WhiteboardsApiService> {
  constructor(state: WhiteboardsState, api: WhiteboardsApiService) {
    super(state, api);
  }

  public createWhiteboard(payload, config?: RequestConfig): Observable<Whiteboard> {
    return this.post$(payload, config);
  }

  public createWhiteboardTemplate$(whiteboardId: string, payload: WhiteboardTemplatePayload): Observable<Whiteboard> {
    return this.post$(payload, {
      ...new RequestConfig(),
      url: this.apiService.whiteboardTemplateEndpoint(whiteboardId),
      queryParams: {
        saveAsTemplate: true,
      },
    });
  }

  public createWhiteboardFromTemplate$(whiteboardId: string, config?: RequestConfig): Observable<Whiteboard> {
    return this.post$(
      {},
      {
        ...config,
        url: this.apiService.whiteboardTemplateEndpoint(whiteboardId),
        queryParams: {
          saveAsTemplate: false,
        },
      }
    );
  }
}
